import { useSubmittedToursQuery } from '@/graphql/generated/hooks'
import { GuardTourStatus } from '@/graphql/generated/schemas'

export enum SubmittedTourStatus {
  COMPLETE = 'Complete',
  INCOMPLETE = 'Incomplete',
  IN_PROGRESS = 'In Progress',
  UNKNOWN = 'Unknown',
}

export type SubmittedToursRowDataType = {
  id: string
  facilityId: string
  facilityName: string
  facilityAddress: string
  tourPlanId: string
  tourPlan: string
  guardFullName: string
  submittedTime: string
  status: GuardTourStatus
}

export type SubmittedToursListType = ReturnType<
  typeof useSubmittedToursQuery
>['data']['guardTours']['edges']

export type SubmittedToursRefetchType = ReturnType<
  typeof useSubmittedToursQuery
>['refetch']
